// extracted by mini-css-extract-plugin
export default {"default":"default__CX_LG","checkmarks":"checkmarks__oBJal default__CX_LG","sm":"sm__XvuKm","checkmarks-reverse":"checkmarks-reverse__vWvw4 checkmarks__oBJal default__CX_LG"};